import { Badge, Drawer, IconButton, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from '../../assets/logo.svg'
import useStyles from './styles'
import { Menu } from '@material-ui/icons';
import search from '../../assets/search.svg'
import cart from '../../assets/cart.svg'

const NavbarDrawer = ({ loggedIn, onSearchOpen, totalItems }) => {

    const location = useLocation();
    const classes = useStyles()

    const [opened, setOpened] = useState();

    const logout = () => { }

    useEffect(() => {
        setOpened(false)
    }, [location])

    return (
        <>
            <Drawer
                open={opened}
                onClose={() => setOpened(false)}
            >
                <li>
                    <Typography varient="h6" className={classes.title} color="inherit" component={Link} to="/">
                        <img src={logo} alt="LOGO GIFTSWAP" height="25px" className={classes.image} style={{ marginTop: -10 }} />
                        <span className="h4 open-font-condensed mt-3" style={{ display: "inline-block" }}>
                            GIFTSWAP
                        </span>
                    </Typography>
                </li>
                <li className={` ${location.pathname === '/' ? "active" : ""}`} ><Link to="/" >Buy gift cards</Link></li>
                <li className={` ${location.pathname === '/products' ? "active" : ""}`} ><Link to="/products" >Catalog</Link></li>
                {/* <li className={` ${location.pathname === '/promos' ? "active" : ""}`}>Promo</li> */}
                {/* <li className={` ${location.pathname === '/deals' ? "active" : ""}`}>Deals</li> */}
                <li className={` ${location.pathname === '/blog' ? "active" : ""}`}><Link to="/blog" >Blog</Link></li>
                {loggedIn && <li className={` ${location.pathname === '/myorders' ? "active" : ""}`}><Link to="/myorders">My Orders</Link></li>}
                {!loggedIn ? (
                    <>
                        <li className="underline">
                            <Link to={"/auth"}>Create account</Link>
                        </li>
                        <li className="center">
                            <Link to={'/auth/login'} className="btn btn-black">Login</Link>
                        </li>
                    </>
                ) :
                    <li onClick={logout} className="btn">Logout</li>
                }
            </Drawer>
            <IconButton onClick={onSearchOpen}><img src={search} className="site-icon search" alt="search" /> </IconButton>
            <IconButton>
                <Badge badgeContent={totalItems} color="secondary">
                    <Link to="/cart">
                        <img src={cart} className="site-icon search" alt="cart" />
                    </Link>
                </Badge>
            </IconButton>
            <IconButton onClick={() => setOpened(!opened)}>
                <Menu></Menu>
            </IconButton>
        </>
    )
}

export default NavbarDrawer;